const IconNames: { [Keys: string]: string } = {
  ArrowLeft: 'arrow-left',
  ArrowRight: 'arrow-right',
  ArrowUp: 'arrow-up',
  Bell: 'bell',
  Calendar: 'calendar',
  Cellphone: 'cellphone',
  Check: 'check',
  Checkmark: 'checkmark',
  Child: 'child',
  CreditCard: 'credit-card',
  ChevronCircle: 'chevron-circle',
  ChevronDown: 'chevron-down',
  ChevronRight: 'chevron-right',
  ChevronLeft: 'chevron-left',
  ChevronUp: 'chevron-up',
  DollarSign: 'dollar-sign',
  HeadPhones: 'headphones',
  HelpCircle: 'help-circle',
  Home: 'home',
  Instagram: 'instagram',
  Linkedin: 'linkedin',
  Location: 'location',
  LogIn: 'log-in',
  LogOut: 'log-out',
  Mail: 'mail',
  Menu: 'menu',
  Minus: 'minus',
  MinusCircle: 'minus-circle',
  Newspaper: 'newspaper',
  Percent: 'percent',
  Plus: 'plus',
  PlusCircle: 'plus-circle',
  Search: 'search',
  Share: 'share',
  Star: 'star',
  Settings: 'settings',
  Tiktok: 'tiktok',
  User: 'user',
  Users: 'users',
  Whatsapp: 'whatsapp',
  Wifi: 'wifi',
  XClose: 'x-close',
};

export default IconNames;
